import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "edit-modal-content__main-content main-content" }
const _hoisted_2 = { class: "main-content__container" }
const _hoisted_3 = { class: "main-content__change-basic-info" }
const _hoisted_4 = { class: "main-content__select-input-content select-input-content" }

import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { ref, computed } from 'vue';
import SelectInput from '@/corePagesModule/SelectInput/SelectInput.vue';
import { AllBusinessesForSupplierForecastStore } from '../pages/useAllBusinessesForSupplierForecastStore';
import { storeToRefs } from 'pinia';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import MultipleUserSelectInput from '@/corePagesModule/user/SelectInput/MultipleUserSelectInput.vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'EditForecastModal',
  props: {
    indexOfSelectInput: { default: 1 },
    store: {}
  },
  setup(__props: any) {

const props = __props;

//変数
const t = i18n.t;

const isOpenSelectInput = ref(false);

const { state } = storeToRefs(props.store);

const modalState = computed({
  /**
   * getter
   */
  get: () => {
    return state.value.editForecastModalState.modalState;
  },
  /**
   * setter
   * @param value - value
   */
  set: (value) => {
    state.value.editForecastModalState.modalState = value;
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": modalState.value,
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('適用'),
    "modal-width": 764,
    "is-disabled-next-button": _ctx.store.isDisabledApplyEditButton,
    onOnBack: _cache[1] || (_cache[1] = ($event: any) => (modalState.value = false)),
    onOnNext: _ctx.store.onApplyEdit
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('仕入先内示:編集')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('チェックが付いている選択済の内示に対して、担当者名とキーワードを一括適用で修正できます。')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(MultipleUserSelectInput, {
                "select-input-index": _ctx.indexOfSelectInput,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(state).editForecastModalState.selectedStaffIdList = $event))
              }, null, 8, ["select-input-index"])
            ])
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "main-content__change-keyword-container change-keyword-container" }, null, -1))
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button", "onOnNext"]))
}
}

})